<template>
  <base-container class="layout-column" ref="container" :isLoading="loading">
    <artisan-group style="flex: 1; overflow-y: auto" title="术前检查">
      <el-table v-if="projectList.length > 0" :data="projectList" style="width: 100%">
        <el-table-column
        header-align="center"
        align="center"
        prop="projectName"
        label="项目名称"
        width="120"
        >
        </el-table-column>
        <el-table-column
        header-align="center"
        align="center"
        prop="reportStatus"
        label="报告状态"
        width="90"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.reportStatus === '1'" class="color-success">已出报告</span>
            <span v-if="scope.row.reportStatus === '0'" class="color-danger">待出报告</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope" v-if="scope.row.reportStatus === '1'">
            <i class="el-icon-view" style="color: #1989fa !important"></i>
            <span class="color-primary margin-h3" @click="viewDetail(scope.row)">查看</span>
          </template>
        </el-table-column>
      </el-table>
      <el-empty v-else  description="暂无检查项目" :image-size="200"></el-empty>
    </artisan-group>
    <artisan-group style="flex: 1; overflow-y: auto" title="评估详情">
      <div style="padding: 12px 0 0 12px;">评估结果</div>
      <div style="padding: 14px;">
        <el-radio v-model="evaluateResult" label="pass" :disabled="disabledExamine">通过</el-radio>
        <el-radio v-model="evaluateResult" label="reject" :disabled="disabledExamine">不通过</el-radio>
      </div>
      <div style="padding-left: 12px;">评估说明</div>
      <div style="padding: 12px 0 12px 12px;">
        <el-input
        :disabled="disabledExamine"
        type="textarea"
        :autosize="{minRows: 4}"
        placeholder="请输入内容"
        v-model="evaluateRemark"
        maxlength="300"
        show-word-limit
        ></el-input>
      </div>
      <div style="display: flex;justify-content: end;" v-if="!disabledExamine">
        <el-button
          type="primary"
          size="mini"
          @click="examine"
          icon="el-icon-check"
          >
            确认提交
        </el-button>
      </div>
    </artisan-group>

  </base-container>
</template>

<script>
  import { getSchedules, recommend, reserve, change } from "@/api/jc/reserve";
  import moment from "moment";
  import {evaluate} from "@/api/op/record";
  export default {
    props: {
      billId: {
        type: String,
        default: "",
      },
      status: {
        type: String,
        default: "",
      },
      remark: {
        type: String,
        default: "",
      },
      projectList: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {

        evaluateResult: '',
        evaluateRemark: '',
        loading: false,
      };
    },
    computed: {
      disabledExamine() {
        return 'wait' !== this.status
      },
    },
    watch: {
      billId() {
        this.loadData();
      },
      status() {
        if (this.status) {
          this.evaluateResult = this.status;
        }
      },
      remark() {
        this.evaluateRemark = this.remark;
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      viewDetail(row) {
        this.$emit("viewDetail", row);
      },

      loadData() {
        if (this.billId) {
          // this.loading = true;
          // getSchedules(this.billId)
          //   .then((res) => {
          //     this.resList = res.data.data;
          //     this.loading = false;
          //     recommend(this.billId).then((res) => {
          //       const data = res.data.data;
          //       this.recommendDate = data.reserveDate;
          //       this.recommendRoomId = data.resourceId;
          //       this.recommendScheduleId = data.scheduleId;
          //       if (this.isRecommend) {
          //         this.roomId = data.resourceId;
          //         this.selDate = moment(data.reserveDate).toDate();
          //         this.scheduleId = data.scheduleId;
          //       }
          //     });
          //   })
          //   .catch(() => {
          //     this.loading = false;
          //   });
        }
      },
      examine() {
        this.$refs.container
          .confirm({ msg: "确认提交？", width: "100%" })
          .then((res) => {
            this.loading = true;
            const param = {
              evaluateRemark: this.evaluateRemark,
              status: this.evaluateResult,
              id: this.billId,
            }
            evaluate(param)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "提交成功！",
                });
                this.$emit("evaluated", param);
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
          });
      },

    },
  };
</script>

<style lang="scss" scoped>
  .day-container {
    position: relative;
    height: 40px;
  }

  .day-content {
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  .day-select {
    display: block;
    position: absolute;
    bottom: 2px;
    right: 2px;
    height: 15px;
    color: #f56c6c;
  }

  .day-schedule {
    font-size: smaller;
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25px;
    height: 25px;
    line-height: 20px;
  }

  .day-schedule-danger {
    background-image: url("/img/triangle_danger.png");
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
  }

  .day-schedule-success {
    background-image: url("/img/triangle_success.png");
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
  }
  .schedule-item {
    border: 1px #dcdfe6 solid;
    padding: 5px;
    cursor: pointer;
    position: relative;
  }
  .schedule-item-recommend {
    position: absolute;
    top: 0;
    right: 3px;
  }
  .schedule-item-select {
    border: 1px #409eff solid;
    color: #409eff;
  }
  .schedule-item-disabled {
    color: #dcdfe6;
  }
  .schedule-select {
    display: block;
    position: absolute;
    top: 20px;
    left: 7px;
    color: #f56c6c;
  }
</style>
